window.BOLD = window.BOLD || {}
BOLD.BMS = BOLD.BMS || {}
BOLD.BMS.Medshop = BOLD.BMS.Medshop || {}


BOLD.BMS.Medshop.SeachResults = function(search_string, result_types, total_results, settings, options){
  if(document.readystate === 'complete'){
    this.init(search_string, result_types, total_results, settings, options)
  } else {
    document.addEventListener('DOMContentLoaded', function(){
      this.init(search_string, result_types, total_results, settings, options)
    }.bind(this) );
  }
}

BOLD.BMS.Medshop.SeachResults.defaults = {
  possibleResultTypes:['product', 'article', 'page'],
  productAreaSelector:'.productgrid--items',
  pageAreaSelector:'.productgrid--footer-results-list-page',
  articleAreaSelector:'.productgrid--footer-results-list-article',
  loadingElementClassName:'search--results-loading',
  noResultsTitle:'',
  noResultsElementType:'li',
  productResultTemplate:'<li><a href="{{data.url}}">{{data.title}}</a></li>',
  articleResultTemplate:'<li><a href="{{data.url}}">{{data.title}}</a></li>',
  pageResultTemplate:'<li><a href="{{data.url}}">{{data.title}}</a></li>',
  customResultViewName:'json',
  loadingElementInnerHTML:'',
  loadRemainingResultsText:'Show {{remaining_results}} more results',
  additionalResultsButtonClasses: 'search--load-more button-secondary',
  additionalResultsButtonText: 'Load more'
}

BOLD.BMS.Medshop.SeachResults.prototype = {
  init: function(search_string, result_types, total_results, settings, options){
    this.settings = settings;
    this.saveOptions(options);

    this.search_string = search_string;
    this.result_types = result_types;
    this.total_results = total_results;
    this.last_page_loaded = 0;
    this.loaded_results = { total:0 };
    for(var t=0; t<this.options.possibleResultTypes.length; t++){
      var type = this.options.possibleResultTypes[t];
      this.loaded_results[type] = 0;
    }
    this.noResultMessages = [];

    this.prepareTemplates();
    this.saveDisplayElements();
    this.prepareAdditionalResultsButton();

    this.loadResults();
  },
  saveOptions: function(options){
    options = options || {};
    this.options = {};
    var defaults = BOLD.BMS.Medshop.SeachResults.defaults;
    for(var key in defaults){
      this.options[key] = (typeof options[key] !== 'undefined' ? options[key] : defaults[key]);
    }
  },
  prepareTemplates:function(){
    this.templates = {
      product: Handlebars.compile(this.options.productResultTemplate),
      page: Handlebars.compile(this.options.pageResultTemplate),
      article: Handlebars.compile(this.options.articleResultTemplate)
    }
  },
  loadResults:function(){
    this.showLoaderElement();
    var page = this.last_page_loaded + 1;
    fetch('/search' + location.search + '&page=' + page + '&view=' + this.options.customResultViewName)
         .then(function(response){ return response.json() })
         .then(this.onResultsLoaded.bind(this));
    this.last_page_loaded = page;
  },
  onResultsLoaded:function(response){
    var results = response.results;
    this.loaded_results.total += results.length;
    this.removeNoResultsText();

    for(var r=0; r<results.length; r++){
      var result = results[r];
      var type = result.object_type;

      this.loaded_results[type]++;
      var renderFunction = this[result.object_type + 'Render'];
      renderFunction && renderFunction.bind(this)(result);
    }
    this.hideLoaderElement();
    this.showNoResultsText();
    this.toggleAdditionalResultsButton();
    BOLD.common.eventEmitter.emit('products_loaded');
    BOLD.common.eventEmitter.emit('BMS.search_results_loaded', results);
    BOLD.common.eventEmitter.emit('images_loaded', this.DOM.productArea.querySelectorAll('img'));
  },
  removeNoResultsText:function(){
    for(var m=0; m<this.noResultMessages.length; m++){
      var message = this.noResultMessages[m];
      message.parentElement && message.parentElement.removeChild(message);
    }
    this.noResultMessages = [];
  },
  showNoResultsText:function(){
    for(var t=0; t<this.options.possibleResultTypes.length; t++){
      var type = this.options.possibleResultTypes[t];
      if(this.loaded_results[type] == 0){
        this.displayNoresultsMessage(type);
      }
    }
  },
  displayNoresultsMessage:function(resultType){
    var wrapper = this.DOM[resultType + 'Area'];
    if(!wrapper){
      return;
    }
    wrapper.appendChild(this.createNoResultMessageElement());

  },
  createNoResultMessageElement:function(){
    var message = document.createElement(this.options.noResultsElementType);
    message.innerText = this.options.noResultsTitle;
    this.noResultMessages.push(message);
    return message;
  },
  productRender:function(product){
    if(!product.hidden){
      this.DOM.productArea.innerHTML += this.templates.product(product);
    }
  },
  articleRender:function(article){
    this.DOM.articleArea.innerHTML += this.templates.article(article);
  },
  pageRender:function(page){
    this.DOM.pageArea.innerHTML += this.templates.page(page);
  },
  saveDisplayElements:function(){
    this.DOM = {
      productArea: document.querySelector(this.options.productAreaSelector),
      pageArea: document.querySelector(this.options.pageAreaSelector),
      articleArea: document.querySelector(this.options.articleAreaSelector)
    }


    this.DOM.productLoadingElement = this.createLoadingElement();
    this.showLoaderElement();
  },
  createLoadingElement:function(){
    var loadingElement = document.createElement('div');
    loadingElement.innerHTML = this.options.loadingElementInnerHTML;
    loadingElement.className = this.options.loadingElementClassName;
    return loadingElement;
  },
  showLoaderElement:function(){
    this.DOM.productLoadingElement && this.DOM.productArea.appendChild(this.DOM.productLoadingElement);
  },
  hideLoaderElement:function(){
    var loadingElement = this.DOM.productLoadingElement;
    if(!loadingElement || !loadingElement.parentElement){
      loadingElement = this.DOM.productLoadingElement = this.DOM.productArea.querySelector('.' + this.options.loadingElementClassName);
    }
    loadingElement && loadingElement.parentElement.removeChild(loadingElement);
  },
  prepareAdditionalResultsButton:function(){
    var additionalResultsButton = this.DOM.additionalResultsButton = document.createElement('button');
    additionalResultsButton.className = this.options.additionalResultsButtonClasses;
    additionalResultsButton.innerText = this.options.additionalResultsButtonText;
    additionalResultsButton.addEventListener('click', this.onAdditionalResultsButtonClick.bind(this));
  },
  onAdditionalResultsButtonClick:function(evt){
    evt.preventDefault();
    this.showLoaderElement();
    this.hideAdditionalResultsButton();
    this.loadResults();
  },
  toggleAdditionalResultsButton:function(){
    if(this.total_results > this.loaded_results.total){
      this.showAdditionalResultsButton();
    } else {
      this.hideAdditionalResultsButton();
    }
  },
  showAdditionalResultsButton:function(){
    this.DOM.productArea.appendChild(this.DOM.additionalResultsButton);
  },
  hideAdditionalResultsButton:function(){
    this.DOM.additionalResultsButton.parentElement && this.DOM.productArea.removeChild(this.DOM.additionalResultsButton);
  }
}
